import { AdminElementsWrapper, SecondaryButton } from 'components';
import { StyledAddminAddTransaction } from './styles';
import { useTranslation } from 'react-i18next';
import { useId } from 'react';
import {apiAdminRoutes} from '../../../../lib';
import {useSelector} from 'react-redux';
import {selectAuth} from '../../../../store/slices/authSlice';

interface IAddminAddTransactionProps {
  children?: React.ReactNode;
}
export const AddminAddTransaction = () => {
  const { t } = useTranslation();
  const { token } = useSelector(selectAuth);

  const submitHandler: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const { elements } = event.currentTarget;
    if ('transactionHash' in elements) {
      const transactionId = (elements.transactionHash as HTMLInputElement).value;
      fetch(apiAdminRoutes.apiAdminCalculatePayments(), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          transactionId,
        }),
      });
    }
  };
  const inputId = useId();
  const heading = t('adminPage.addTransaction.heading');
  return (
    <StyledAddminAddTransaction>
      <AdminElementsWrapper>
        <h3 className="heading">{heading}</h3>
        <form className="form" onSubmit={submitHandler}>
          <label htmlFor={inputId} hidden>
            {heading}
          </label>
          <input type="text" className="input" id={inputId} name="transactionHash" />
          <SecondaryButton
            type="submit"
            outline
            iconFirst
            title="Add"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M13 7.5H2M7.5 2V13"
                  stroke="white"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
          />
        </form>
      </AdminElementsWrapper>
    </StyledAddminAddTransaction>
  );
};
